import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import "./lib/i18n";
import './lib/error-monitoring';
import './lib/sentry'; // Initialize Sentry (only in production)

createRoot(document.getElementById("root")!).render(<App />);
